module.exports = __webpack_public_path__ + "img/Ballon_Water.4fafd523.svg";